import { PortfolioMilestoneStatus, Study } from '@models';

/**
 * Utility functions for handling milestone tooltips in
 * the portfolio table on portfolio page and on portfolio summary modal.
 */
const MILESTONE_TOOLTIP_FALLBACK_VALUE = '--';

interface MilestoneTooltipDeltaParts {
  bold: string;
  regular: string;
}

function shouldShowMilestoneTooltip(study: Study): boolean {
  if (!study.milestoneDates) {
    return false;
  }

  return study.milestoneStatus !== PortfolioMilestoneStatus.DatesNotAvailable;
}

function getMilestoneTooltipTitle(study: Study): string {
  const milestoneTitle = getValidTooltipText(study.milestoneDates?.nameTooltip);
  const nextMilestone = getValidTooltipText(study.nextMilestone);
  return milestoneTitle ?? nextMilestone ?? MILESTONE_TOOLTIP_FALLBACK_VALUE;
}

function getMilestoneTooltipDeltaParts(study: Study): MilestoneTooltipDeltaParts {
  const delta =
    getValidTooltipText(study.milestoneDates?.delta) ?? MILESTONE_TOOLTIP_FALLBACK_VALUE;
  const separatorIndex = delta.indexOf(':');

  if (separatorIndex === -1) {
    return { bold: delta, regular: '' };
  }

  return {
    bold: delta.slice(0, separatorIndex + 1),
    regular: delta.slice(separatorIndex + 1)
  };
}

function getValidTooltipText(value: string | null | undefined): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmedValue = value.trim();
  if (!trimmedValue || trimmedValue.toUpperCase() === 'NULL') {
    return null;
  }

  return trimmedValue;
}

export { getMilestoneTooltipDeltaParts, getMilestoneTooltipTitle, shouldShowMilestoneTooltip };
export type { MilestoneTooltipDeltaParts };
